import { ROUTE } from '../../../App';
import Button from '../../../components/Buttons/Button';
import cn from '../../../lib/classNames';

import mobileApp from './images/mobileApp.svg';

import styles from './TrySafeXploreAIForPersonalUse.module.scss';

type TrySafeXploreAIForPersonalUseType = {
	classPageContent?: string;
};

export default function TrySafeXploreAIForPersonalUse(props: TrySafeXploreAIForPersonalUseType) {
	const { classPageContent } = props;
	return (
		<div className={styles.wrap}>
			<div className={cn(styles.content, classPageContent)}>
				<div className={styles['text-block']}>
					<h3 className={styles.title}>Try Safe-xplore AI for personal use</h3>
					<div className={styles.description}>
						Safe-xplore AI is also available for personal use — get started by generating a
						personalized report for free.
					</div>
					<div className={styles['button-wrap']}>
						<Button
							className={styles.button}
							variant="filled"
							elementType="navigate"
							color="primary"
							size="large"
							href={ROUTE.welcome}
							target="_blank"
						>
							Learn more
						</Button>
					</div>
				</div>
				<div className={styles.image}>
					<img src={mobileApp} alt="Try Safe-xplore AI for personal use" />
				</div>
			</div>
		</div>
	);
}
